itsoftApp.createModule("filters", function () {
   var module = this;
   var resetButton = document.querySelector(".js-filter-reset");
   var searchFilter = document.querySelector(".js-search-filter");
   var initUrl = true;

   var filterCatalog = function (data) {
        itsoftApp.modules.loadItems.loadItems(data);
   }

   var resetFilters = function (form, status) {
      var selectsWrapper = form.querySelectorAll(".js-select");
      var url = "?";
      
      Array.prototype.forEach.call(selectsWrapper, function (selectWrapper, index) {
          var select = selectWrapper.querySelector("select");
          var customSelect = selectWrapper.querySelector(".choices__inner .choices__item");

          var selectName = select.name;
          var selectValue = "";

          if (index === 0) {
            url += selectName + "=" + selectValue;
          } else {
            url += "&" + selectName + "=" + selectValue;
          }
      });

      url.replace(/\s/g, '+');
        var query = DEBUG ? "/ajax/catalog.php" : "./" + url;

        // if (status) {
          history.replaceState("", "", url)
        // }

        itsoftApp.utils.load(query, filterCatalog);

        Array.prototype.forEach.call(itsoftApp.modules.select.selects.filters, function (choice) {
          choice.removeActiveItems();
        });

        Array.prototype.forEach.call(selectsWrapper, function (selectWrapper, index) {
          var placeholderEl = selectWrapper.querySelector(".choices__list--dropdown");
          var placeholder = placeholderEl.getAttribute("data-placeholder");

          var mainInput = selectWrapper.querySelector(".choices__list--single");
          var choicesItem = mainInput.querySelector(".choices__item");
          
          if (!choicesItem) {
            var divEl = document.createElement("div");
            divEl.className = "choices__item form__select-placeholder choices__item--selectable";
            if (placeholder) {
              divEl.textContent = placeholder;
            }
          }

          if (!choicesItem) {
            mainInput.appendChild(divEl);
          }
        });
   }

   var initFilters = function (form) {
        var url = "?";

        var selectsWrapper = form.querySelectorAll(".js-select");

        var searchInput = form.querySelector(".js-search-input");

        if (selectsWrapper.length > 0) {
          Array.prototype.forEach.call(selectsWrapper, function (selectWrapper, index) {
            var select = selectWrapper.querySelector("select");
            var customSelect = selectWrapper.querySelector(".choices__inner .choices__item");

            var selectName = select.name;
            var selectValue = customSelect.getAttribute("data-value");

            if (index === 0) {
              url += selectName + "=" + selectValue;
            } else {
              url += "&" + selectName + "=" + selectValue;
            }
          });
        }

        if (searchInput) {
            url = "?filter=" + searchInput.value;
        }

        url.replace(/\s/g, '+');

        if (selectsWrapper.length > 0) {
          var query = DEBUG ? "/ajax/catalog.php" : "./" + url;
        } else {
          var query = DEBUG ? "/ajax/substances.php" : "./" + url;
        }

        if (initUrl) {
          history.pushState("", "", url)
          initUrl = false;
          console.log(true)
        } else {
          history.replaceState("", "", url)
          console.log(false)
        }

        itsoftApp.utils.load(query, filterCatalog);
   }

   if (resetButton) {
    var form = document.querySelector(".filters__form");

      resetButton.addEventListener("click", function () {
        resetFilters(form);
      });

      window.addEventListener("popstate", function () {
        resetFilters(form, true);
      });
   }

   if (searchFilter) {
      var searchInput = searchFilter.querySelector(".js-search-input");

      if (searchInput) {
        var debouncer = itsoftApp.utils.debouncer(function () {
            initFilters(searchFilter);
        }, 1500);

        searchInput.addEventListener("input", debouncer);
      }
   }

   module.callback = initFilters; 
});